import React from 'react';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';

import { BaseText } from '../../common/BaseText';
import { Touchable } from '../../common/Touchable';

const TouchableContainer = styled(Touchable)({
  size: 36,
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '$background0',
});

const Text = styled(BaseText)({
  variant: 'text.xxlarge',
});

export interface IEmoji {
  id: string;
  symbol: string;
}

export interface IEmojiItemProps {
  item: IEmoji;
  onPress(item: IEmoji): void;
}

export const EmojiItem = observer(
  ({ item, onPress }: IEmojiItemProps) => {
    return (
      <TouchableContainer onPress={() => onPress(item)}>
        <Text>{item.symbol}</Text>
      </TouchableContainer>
    );
  },
);
